<template>
    <div class="builder-sidebar-content">
        <slot></slot>
    </div>
</template>
